import {useContext} from 'react'

import Context from '@s-ui/react-context'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

export const useGetTrackingEvents = () => {
  const {domain} = useContext(Context)
  const config = domain.get('config')
  const {TRACKING_EVENT_CONTEXTS, TRACKING_EVENT_NAMES} = config.get('tracking')

  const {track} = useAnalyticsTrack()

  const trackUpdatedCalculationsEvents = async ad => {
    const eventData = await domain.get('get_event_tracking_data_use_case').execute({
      ad: {
        ...ad,
        financingData: 'updatedCalculations'
      },
      event: TRACKING_EVENT_NAMES.FINANCING_CALCULATOR_LOAN_DATA_VISUALIZED
    })
    track(eventData)
  }

  const trackLegalContent = async ad => {
    const eventData = await domain.get('get_event_tracking_data_use_case').execute({
      ad,
      context: TRACKING_EVENT_CONTEXTS.FINANCING_FDA_CALCULATOR,
      event: TRACKING_EVENT_NAMES.FINANCING_DETAIL_LEGAL_CONDITIONS_CLICKED
    })

    track(eventData)
  }

  const trackTermsChangeEvents = async (ad, value) => {
    const eventData = await domain.get('get_event_tracking_data_use_case').execute({
      ad: {...ad, selectedTerm: value},
      event: TRACKING_EVENT_NAMES.FINANCING_CALCULATOR_TERM_SELECTED_B2C
    })

    track(eventData)
  }

  const trackEntryChangeEvents = async (ad, value) => {
    const eventData = await domain.get('get_event_tracking_data_use_case').execute({
      ad: {...ad, selectedEntry: value},
      event: TRACKING_EVENT_NAMES.FINANCING_CALCULATOR_ENTRY_FEE_SELECTED_B2C
    })

    track(eventData)
  }

  const trackCTA = async (ad, financingData) => {
    const eventData = await domain.get('get_event_tracking_data_use_case').execute({
      ad: {
        ...ad,
        financingData: {
          ...financingData
        }
      },
      context: TRACKING_EVENT_CONTEXTS.FINANCING_LOAN_APPLICATION_FDA,
      event: TRACKING_EVENT_NAMES.FINANCING_CALCULATOR_LOAN_APPLICATION_CLICKED_B2C
    })

    track(eventData)
  }

  const trackLoanAplicationFailed = async ad => {
    const eventData = await domain.get('get_event_tracking_data_use_case').execute({
      ad: {...ad},
      event: TRACKING_EVENT_NAMES.FINANCING_CALCULATOR_LOAN_APPLICATION_FAILED_B2C
    })

    track(eventData)
  }

  return {
    trackUpdatedCalculationsEvents,
    trackLegalContent,
    trackTermsChangeEvents,
    trackEntryChangeEvents,
    trackCTA,
    trackLoanAplicationFailed
  }
}
